import type { FC } from 'react';
import { PatternFormat } from 'react-number-format';
import { TextField } from '../TextField';
import type { PatternTextFieldProps } from './PatternTextField.types';

/*
 * This component extends custom TextField component to use format patterns
 */
const PatternTextField: FC<PatternTextFieldProps> = ({ format = '', ...rest }) => (
  <PatternFormat {...rest} format={format} customInput={TextField} autoComplete="off" />
);

export default PatternTextField;
